import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Captcha } from '../components/Captcha';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [captcha, setCaptcha] = useState({ captcha_id: '', captcha_answer: '' });
  const [captchaKey, setCaptchaKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, ...captcha });
      setSent(true);
      toast.success('If that email exists, a reset link has been sent!');
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Something went wrong. Please try again.');
      setCaptcha((prev) => ({ ...prev, captcha_answer: '' }));
      setCaptchaKey((k) => k + 1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="backdrop-blur-2xl bg-black/60 border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.5)] p-8">
          <h1 className="text-3xl sm:text-4xl tracking-tight font-light mb-2 text-center" data-testid="forgot-password-heading">
            Reset Password
          </h1>
          <p className="text-sm text-muted-foreground text-center mb-8">
            Enter your email to receive a password reset link
          </p>

          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-password-sent">
              <div className="p-4 border border-primary/30 bg-primary/10">
                <p className="text-sm">Check your email for the reset link.</p>
              </div>
              <Link to="/login" className="text-primary hover:underline text-sm" data-testid="forgot-back-login">
                Back to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-password-email-input"
                />
              </div>
              <Captcha
                answer={captcha.captcha_answer}
                reloadKey={captchaKey}
                onChange={(patch) => setCaptcha((prev) => ({ ...prev, ...patch }))}
              />
              <Button
                type="submit"
                className="w-full rounded-full bg-primary hover:bg-primary/90"
                disabled={loading}
                data-testid="forgot-password-submit"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
              <p className="text-center text-sm text-muted-foreground">
                Remember your password?{' '}
                <Link to="/login" className="text-primary hover:underline" data-testid="forgot-login-link">
                  Sign in
                </Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
